import BottomNavBar from 'components/BottomNavBar'
import SpliTemplateScreen from 'layouts'
import NavbarComponent from 'layouts/navbar/NavbarComponent'
import SidebarComponent from 'layouts/sidebar/SidebarComponent'
import React from 'react'
import { Outlet } from 'react-router-dom'

const DashboardAppShell = () => {

  return (
    <>
    <SpliTemplateScreen>
      <NavbarComponent />
        <SidebarComponent
          activeLinkColor={"#FFFFFF"}
          activeLinkBgColor={"#009688"}
          colorOnHover={"white"}
          linkColor="#111827"
          color="#111827"
        />
      <Outlet 
      
      />
    </SpliTemplateScreen>
      <BottomNavBar/>
      </>
  )
}

export default DashboardAppShell